export default "__VITE_PUBLIC_ASSET__06e6b90f__"